import React from 'react';
import { Container, Placeholder } from '@/components';
import styles from './categories.module.scss';

const CategoriesSkeleton = () => {
  return (
    <Container className={styles.categories__carousel_skeleton}>
      {Array.from({ length: 20 }).map((_, index) => (
        <div
          className={styles.categories_carousel__placeholder_category}
          key={index}
        >
          <Placeholder
            className={styles.categories_carousel__placeholder_image}
          />
          <Placeholder
            className={styles.categories_carousel__placeholder_title}
          />
        </div>
      ))}
    </Container>
  );
};

export { CategoriesSkeleton };
